import React from "react"
import Helmet from "react-helmet"

import MainAppChrome from "../../chrome/MainAppChrome"
import Hero from "../../../components/ui-Hero"
import HeroTitle from "../../../components/ui-HeroTitle"
import HaloPicture from "../../../components/HaloPicture"
import { Container, Row, Col } from "Grid"
import { Text, TextList, Title, Header, Headline } from "Text"
import Divider from "Divider"
import CancellationPolicy from "../../CancellationPolicy"

export default function Booking({ match }) {
  const serviceId = match.params?.serviceId

  return (
    <MainAppChrome>
      <Helmet>
        <title>Julie Alexander Lactation Support</title>
        <meta
          name="description"
          content="Non-judgmental support from an IBCLC certified lactation consultant to reach your lactation and breastfeeding goals. Be confident in feeding your infant helping them to grow up happy and healthy."
        />
        <script src="https://intakeq.com/js/widget.min.js?1"></script>
      </Helmet>

      <div id="intakeq"></div>

      <Divider gutterBottom />
      <Container>
        <CancellationPolicy />
      </Container>
    </MainAppChrome>
  )
}
